import React, { useEffect, useState } from "react";
import api, { apiError } from "../lib/api";
import { nf } from "../lib/format";
import { toast } from "sonner";

const ENDPOINTS = { adjusted_qty: "adjusted-qty", adjusted_hours: "adjusted-hours", budget_adj_qty: "budget-adj-qty", standard_labor_rate: "ot-rate" };
const DECIMALS = { adjusted_hours: 1, standard_labor_rate: 2 };

export function AdjustedCell({ row, pid, field, canEdit, onSaved }) {
  const endpoint = ENDPOINTS[field];
  const decimals = DECIMALS[field] || 0;
  const [val, setVal] = useState(String(row[field] ?? 0));
  const [saving, setSaving] = useState(false);
  useEffect(() => { setVal(String(row[field] ?? 0)); }, [row, field]);

  const commit = async () => {
    const num = parseFloat(val) || 0;
    if (num === (row[field] ?? 0)) return;
    setSaving(true);
    try {
      await api.patch(`/projects/${pid}/cost-codes/${row.id}/${endpoint}`, { [field]: num });
      toast.success(`Updated ${row.cost_code}`);
      onSaved();
    } catch (e) { toast.error(apiError(e.response?.data?.detail)); setVal(String(row[field] ?? 0)); }
    finally { setSaving(false); }
  };

  if (!canEdit) {
    return <span className="font-mono" data-testid={`${endpoint}-readonly-${row.line_id || row.cost_code}`}>{nf(row[field], decimals)}</span>;
  }
  const tip = row[`${field}_by`]
    ? `Last edited by ${row[`${field}_by`]}${row[`${field}_at`] ? " on " + new Date(row[`${field}_at`]).toLocaleString() : ""}`
    : "Not yet edited";
  return (
    <input
      value={val}
      title={tip}
      onChange={(e) => setVal(e.target.value)}
      onClick={(e) => e.stopPropagation()}
      onBlur={commit}
      onKeyDown={(e) => { if (e.key === "Enter") e.currentTarget.blur(); }}
      inputMode="decimal"
      data-testid={`${endpoint}-input-${row.line_id || row.cost_code}`}
      className={`w-16 text-right font-mono bg-amber-50 border rounded px-1 py-0.5 outline-none focus:border-[#E8791A] ${saving ? "opacity-50" : "border-amber-300"}`}
    />
  );
}
